import { TableCell, TableRow } from '@/shared/ui/table';

interface ShiftsTableSkeletonProps {
  /** Number of placeholder rows to render — size to the page so the table doesn't jump. */
  rows: number;
}

/**
 * Pulsing placeholder rows shown while a shifts page/search is fetching.
 * Mirrors the 8 columns of the shifts table so row height and pagination
 * position stay fixed during the swap.
 */
export function ShiftsTableSkeleton({ rows }: ShiftsTableSkeletonProps) {
  return (
    <>
      {[...Array(rows)].map((_, i) => (
        <TableRow key={`skeleton-${i}`} className="border-border hover:bg-transparent">
          <TableCell>
            <div className="w-10 h-5 rounded bg-muted animate-pulse" />
          </TableCell>
          <TableCell>
            <div className="h-3.5 w-32 rounded bg-muted animate-pulse" />
          </TableCell>
          <TableCell>
            <div className="h-3 w-12 rounded bg-muted animate-pulse" />
          </TableCell>
          <TableCell>
            <div className="h-3 w-14 rounded bg-muted animate-pulse" />
          </TableCell>
          <TableCell>
            <div className="h-3 w-14 rounded bg-muted animate-pulse" />
          </TableCell>
          <TableCell>
            <div className="h-5 w-8 mx-auto rounded-full bg-muted animate-pulse" />
          </TableCell>
          <TableCell>
            <div className="h-5 w-8 mx-auto rounded-full bg-muted animate-pulse" />
          </TableCell>
          <TableCell>
            <div className="flex items-center justify-end gap-1">
              <div className="h-8 w-8 rounded bg-muted animate-pulse" />
              <div className="h-8 w-8 rounded bg-muted animate-pulse" />
            </div>
          </TableCell>
        </TableRow>
      ))}
    </>
  );
}
